import React from 'react'
import { Link, StaticQuery, useStaticQuery } from 'gatsby'
import Img from 'gatsby-image'
import { Container, Row, Col } from 'react-bootstrap'
import './style.scss'

const Homeprime: React.FC = () => {
  const data = useStaticQuery(graphql`
    query {
      file(name: { eq: "pf-photo" }) {
        childImageSharp {
          fluid(maxWidth: 800, maxHeight: 800) {
            ...GatsbyImageSharpFluid
          }
        }
      }
    }
  `)

  return (
    <Row className="test">
      <Col md={6} className="p-5">
        <h2 className="hero-title">Hey let's talk</h2>
        <p className="hero-subtitle"></p>
        <p className="text-left">
          I’m always eager to build innovative solutions on the open web or help
          others find the resources they need to succeed. I specialize in
          Decoupled Drupal & Magento development using frontend Javascript
          frameworks such as React, Angular and Gatsby.
        </p>
        <p className="text-left">
          If you’ve got questions my office door is always open so send me a
          message or hit me up on your favorite social media network.
        </p>
      </Col>
      <Col md={6}>
        <Img
          fluid={data.file.childImageSharp.fluid}
          alt="Photo of Peter Feddo"
        />
      </Col>
    </Row>
  )
}

export default Homeprime

/*
export const query = graphql`
query homePrimeQuery {
  file(name: {eq: "pf-photo"}) {
    childImageSharp {
      fluid(maxWidth: 400, maxHeight: 400) {
        base64
        tracedSVG
        srcWebp
        srcSetWebp
        originalImg
        originalName
      }
    }
  }
}`
*/
